import Styles from "./ModalBox.module.css";
const ModalBox = (props) => {
  const { box, setBox, sgpa } = props;
  // Get the modal
  var modal = document.getElementById("myModal");

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function (event) {
    if (event.target == modal) {
      setBox(false);
    }
  };
  return (
    <div id="myModal" className={Styles.modal}>
      <div className={Styles.modalContent}>
        <span
          className={Styles.close}
          id="close"
          onClick={() => {
            setBox(false);
          }}
        >
          &times;
        </span>
        <p>
          Your SGPA is <b>{sgpa}</b>
        </p>
      </div>
    </div>
  );
};

export default ModalBox;
